import type { PictureConfiguration } from "@brickme/project-core/src/model/picture.ts";
import type { GenericSize } from "@brickme/project-core/src/model/geom.ts";

// This parallels what createBrickedSource does. However we can't directly share it
// because under the hood the resize downscaling is a very early step.
function renderSource(
	canvasCtx: CanvasDrawImage & { readonly canvas: GenericSize<number> },
	canvasSourceImage: HTMLCanvasElement | OffscreenCanvas,
	{
		numberOfBasePlates,
		basePlateSize,
		imageZoom,
		imageZoomOffset,
	}: Pick<
		PictureConfiguration,
		"numberOfBasePlates" | "basePlateSize" | "imageZoom" | "imageZoomOffset"
	>,
) {
	// Create a source image that constrains the image to the picture aspect ratio
	const desiredAspectRatio =
		(numberOfBasePlates.width * basePlateSize) /
		(numberOfBasePlates.height * basePlateSize);
	const desiredAspectRatioWidth = canvasSourceImage.height * desiredAspectRatio;
	const desiredAspectRatioHeight = canvasSourceImage.width / desiredAspectRatio;
	const scaledWidth =
		Math.min(desiredAspectRatioWidth, canvasSourceImage.width) / imageZoom;
	const scaledHeight =
		Math.min(desiredAspectRatioHeight, canvasSourceImage.height) / imageZoom;
	const sourcePixelsPerBrick =
		scaledWidth / (numberOfBasePlates.width * basePlateSize);
	const sourceBounds = {
		x:
			(canvasSourceImage.width - scaledWidth) / 2 -
			imageZoomOffset.x * sourcePixelsPerBrick,
		y:
			(canvasSourceImage.height - scaledHeight) / 2 -
			imageZoomOffset.y * sourcePixelsPerBrick,
		width: scaledWidth,
		height: scaledHeight,
	};

	// drawImage the canvasSourceImage to the canvasCtx
	canvasCtx.drawImage(
		canvasSourceImage,
		sourceBounds.x,
		sourceBounds.y,
		sourceBounds.width,
		sourceBounds.height,
		0,
		0,
		canvasCtx.canvas.width,
		canvasCtx.canvas.height,
	);
}

export default renderSource;
